module.exports = __webpack_public_path__ + "static/media/bubble-active-2.d58e79bf.svg";